import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { ISegmentEventOption } from '../../../../../../../../middlewares/segment/trackEntities/types';
import { SegmentCardType } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onAllClicked = (
    source: SegmentCardType,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const option: ISegmentEventOption = source && {
            name: SegmentCardOptions.TYPE,
            value: SegmentCardType.CARD_INPUT
        };
        dispatch(segmentTrackAction(SegmentCardEvent.COLOUR_TAGS_ALL_CLICKED, option));
    };
    return action;
};
